var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { twMerge } from 'tailwind-merge';
export var SimpleTableCell = function (props) {
    return (_jsx("div", __assign({ className: twMerge('w-fit text-[14px] font-normal leading-5 text-[#14181F]', props.contentClassName, !props.noPadding && 'px-[12px] py-[4px]') }, { children: props.content })));
};
